import React from 'react';
import { PieChart} from 'react-minimal-pie-chart';
import { useTranslation } from 'react-i18next';

import { UnderCapStatusPropTypes } from 'src/components/JobForm/propTypes';
import s from 'src/components/JobForm/JobForm.styles';

export const UnderCapStatus = ({ allFindingCount, pendingFindingCount }) => {
  const { t } = useTranslation();

  return (
    <s.Status>
      <s.PieChartDiv>
        <PieChart        
          segmentsShift={0}
          data={[
            {
              color: '#DC143C',
              value: allFindingCount === 0 ? 0 : pendingFindingCount,
            },
            {
              color: '#d9d9d9',
              value: allFindingCount === 0 ? 1 : allFindingCount - pendingFindingCount,
            },
          ]}
          animationDuration={500}
          style={{
            height: '40px',
            width: '40px',
          }}
          segmentsStyle={{
            transition: 'stroke .3s ease',
          }}
          lineWidth={15}
          startAngle={-90}
          radius={50}
          animationEasing="ease-out"
          label={() => null}
          lengthAngle={360}
          viewBoxSize={[100, 100]}
          animate={false}
        />
        <s.PieChartText>
          {allFindingCount === 0 ? 0 : `${pendingFindingCount}/${allFindingCount}`}
        </s.PieChartText>
      </s.PieChartDiv>
      <s.StatusText pendingFindings>
        {t('PENDING_FINDINGS')}
      </s.StatusText>
    </s.Status>
  );
};

UnderCapStatus.propTypes = UnderCapStatusPropTypes;
